import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function SupportedView() {
  useDocumentTitle('Supported Living-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-13'}
        title={'Supported Living'}
        link={'Supported Living'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                What is supported living?
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">H</span>ousing with
                  support is often called Supported Living or Independent
                  Living. What both of these terms mean is that a person has
                  their own home and support is put in place to help them live
                  independently. This could mean that they are supported for a
                  few hours a week, every day, overnight, or 24 hours a day. The
                  support is carefully planned to meet their needs to live
                  independently.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/brain-injury">
                        Brain injury
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/spinal-injury">
                        Spinal injury
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-values">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">What do we offer?</h2>
                <p className="white-color">
                  Quality Health and Homecare Service Ltd can offer you a wide
                  range of Supported living services. Our staffs are experts in
                  working with disabled people. We support people with:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>Learning disabilities</li>
                    <li className="">Physical disabilities</li>
                    <li>Acquired brain injuries</li>
                    <li>high dependency needs, profound or complex needs</li>
                  </ul>
                </div>
                <p className="white-color">
                  You can request our services for just a few hours a week or
                  for 24-hour care. We support you to live in your own home. We
                  will help you to be independent and have more choices about
                  how you live. We believe that everyone has the right to live
                  how they want. If you want to try new hobbies and activities,
                  we can help you find what is available. If you want to get
                  more involved in your community, we can support you to get out
                  and about.
                </p>
                <p className="white-color">
                  Quality Health and Homecare Services Ltd have very high
                  standards. We make sure all of our staff are well-trained. We
                  make sure that people who use our services feel safe and we
                  respect your privacy. We listen to what you want and what you
                  say about our service.
                </p>
                <p className="white-color">
                  Quality Health and homecare services offer lots of different
                  kinds of support. You can choose what you need. For example,
                  you might need support to visit the gym or support to go
                  swimming. Perhaps you might need support to do your shopping
                  or work out your bills or even personal care. Our support
                  workers have a lot of training to provide a variety of
                  services. If you want, they will also work with your family
                  and with your doctor, nurse, or dentist.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  We support you to achieve your dreams
                </h2>
                <p className="">
                  If you choose supported living, QHHCS will work with you on a
                  person-centred plan. This sets out your hopes and dreams for
                  your life, and the choices you would like to make. Then you
                  will be supported to decide how you are going to make those
                  things happen.
                </p>
                <p>It might include things like</p>
                <div>
                  <ul className="care_bullets2">
                    <li>Holiday plans</li>
                    <li>Managing your money</li>
                    <li>Using public transport</li>
                    <li>Finding a job</li>
                    <li>Making new friends</li>
                    <li>Help with claiming benefits</li>
                    <li>Enrolling in a course</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  We support you to make your choices
                </h2>
                <p className="white-color">
                  We want to hear what you have to say. We will support you to
                  make decisions about your own care. We will listen when you
                  tell us how we can support you better.
                </p>
                <p className="white-color">
                  We recognize that you are the ‘expert on your own life. This
                  means we will support you to take risks and grab opportunities
                  as others do.
                </p>
                <p className="white-color">
                  QHHCS wants the people who use our services to be more
                  involved with how things are run. We do this by:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      Asking Clients to help us make decisions, like choosing
                      Suitable staff members.
                    </li>
                    <li>Managing your money</li>
                    <li>Involving Clients when updating our website</li>
                    <li>Listening to your feedback and opinions</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Night Sitting/Care</h2>
                <p className="">
                  Assistance and reassurance can be provided throughout the
                  night either by waking or sleeping in carers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Live–In Care</h2>
                <p className="white-color">
                  Live-in Care enables anyone with care needs to continue living
                  in their own home with a round-the-clock care worker. Whether
                  you just need some companionship or you have some specific
                  health issues that mean you require extra support, Live-in
                  Care provides a full-time solution and is a realistic and
                  affordable alternative to moving into a care home. Live-in
                  Care enables anyone with care needs to continue living
                  independently in their own home with a round-the-clock care
                  worker.
                </p>
                <p className="white-color">
                  Live-in Care offers the following benefits to you:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      Care in the comfort of your own home and surroundings.
                    </li>
                    <li className="">
                      A personal one-to-one relationship with your carer.{' '}
                    </li>
                    <li>Care tailored to suit individual client needs</li>
                    <li>
                      Live-in carers can be booked for whatever length of time
                      is required.
                    </li>
                    <li>
                      Favorite Carers often return frequently, giving Clients
                      valuable continuity of care.
                    </li>
                    <li>
                      The cost of long-term Live Care compares favorably with
                      Care home fees
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Respite Care</h2>
                <p className="">
                  People who care for someone with dementia, a physical
                  disability, or a chronic illness, occasionally need a break
                  from the responsibility of caring for a friend or relative. We
                  can provide a live-in carer to look after the Client in their
                  own home for as long as required.
                </p>
                <p className="">
                  A carefully selected carer can come and stay in the Clients
                  home for as long as required. The carer will be chosen
                  according to the needs, wishes, and circumstances of the
                  Client and will provide an appropriate level of domestic,
                  physical, and emotional support, 24 hours a day.
                </p>
                <h2 className="compassion">24/7</h2>
                <p className="">
                  Our Company always provides care workers who are able to offer
                  support and assistance 24 hours per day, 365 days per year. We
                  operate an out-of-hours on-call mannered by a member of the
                  management team for emergencies outside of office hours, to
                  maintain total peace of mind and reassurance to Clients,
                  families/advocates, care workers, and social work departments.
                  In short, if you need us, we’re here. Advice is only a phone
                  call away.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Care Assistants/Support Workers</h2>
                <p className="white-color">
                  Our care staff are trained or are working towards NVQ Level 2
                  or 3. All of our staff are approachable, dependable,
                  diligently committed, and understand in depth the needs of
                  Clients. Care assistants/support workers will come to your
                  home for as long or short a period of time as required.
                  Generally, this is from a quarter of an hour onward.
                </p>
                <p className="white-color">
                  A sit-in service is available during the daytime to allow for
                  a relative or main carer to have a break. A night care
                  assistant may also come to either sit or sleep in the house,
                  in order to provide care or company at night. You are never
                  alone with Quality Health and Homecare Services Ltd.
                </p>
                <p className="white-color">
                  Quality Health and Homecare Services Ltd provide a
                  professional caring and supportive approach with the
                  understanding that each Client is an individual. This can only
                  be achieved through dedicated and professional staff.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default SupportedView;
